define(
    ['underscore', 'moment', 'text!./templates/basler-date-combo.html'],
    (_, moment, templateStr) => {
        return ['LocaleService', 'BaslerDateUtilService',
            function (LocaleService, BaslerDateUtilService) { //NOSONAR
                return {
                    restrict: 'E',
                    template: templateStr,
                    scope: {
                        /** Model (value) to select. */
                        model: '=',
                        /** Minimal available date */
                        minSelectDate: '=',
                        /** Maximal available date */
                        maxSelectDate: '=',
                        /** Function to be called when a date has been selected*/
                        onDateSelect: '&',
                        /** Function to be called every time the month or the year has changed*/
                        onChange: '&',
                        /** should combo be displayed with day*/
                        showDay: '=',
                        /** false ore default: model set with date object.
                         *  true: model set with local date object (3 fields day, month and year*/
                        localDate: '=',
                        /** resets given model value to today if it is in the past
                         * NOTE: controllers themselves are executed even they are not used for current screen and therefore cannot reset data
                         * but directives are embedded in the page and executed only, when really visible */
                        resetPastDate: '=',
                        /** Maximal available date */
                        selectedMonth: '=?',
                        /** Maximal available date */
                        selectedYear: '=?',
                    },
                    controllerAs: 'vm',
                    bindToController: true,
                    link: function ($scope, element, attr, vm) {
                        vm.selectedDay = undefined;
                        vm.selectedMonth = $scope.selectedMonth;
                        vm.selectedYear = $scope.selectedYear;
                        vm.selectedDateVariable = undefined;

                        if (vm.resetPastDate) {
                            vm.model.value = BaslerDateUtilService.resetPastDateIfNeeded(vm.model.value);
                        }

                        vm.days = BaslerDateUtilService.getDays();
                        vm.months = BaslerDateUtilService.getMonths();
                        const minYear = moment(vm.minSelectDate).year();
                        const maxYear = moment(vm.maxSelectDate).year();
                        vm.years = _.range(minYear, maxYear + 1).reverse();

                        // Set the default value if any
                        if (vm.model.value) {
                            vm.selectedDay = BaslerDateUtilService.getDay(vm.model.value);
                            vm.selectedMonth = _.find(vm.months, {id: BaslerDateUtilService.getMonthAsNumber(vm.model.value)});
                            vm.selectedYear = BaslerDateUtilService.getYear(vm.model.value);
                            vm.selectedDateVariable = moment(vm.model.value).toDate();
                            if (vm.localDate) {
                                vm.model.value = {
                                    year: vm.selectedYear,
                                    month: vm.selectedMonth.id,
                                    day: vm.selectedDay,
                                };
                            }
                        }
                    },
                    controller: [function () { //NOSONAR
                        const vm = this;
                        let isTouch = 'ontouchstart' in document.documentElement;

                        vm.isTouchDevice = function () {
                            isTouch = 'ontouchstart' in document.documentElement;
                            return isTouch;
                        };

                        vm.buttonDateDayClass = () => {
                            return vm.selectedDay ? ' active' : '';
                        };
                        vm.buttonDateMonthClass = () => {
                            //if day is shown change w50 class to w33
                            let monthClass = 'basler-date-combo-item--w50';
                            if (vm.showDay) {
                                monthClass = 'basler-date-combo-item--w33';
                            }

                            if (vm.selectedMonth) {
                                monthClass += ' active';
                            }
                            return monthClass;
                        };
                        vm.buttonDateYearClass = () => {
                            //if day is shown change w50 class to w33
                            let monthClass = 'basler-date-combo-item--w50';
                            if (vm.showDay) {
                                monthClass = 'basler-date-combo-item--w33';
                            }
                            if (vm.selectedYear) {
                                monthClass += ' active';
                            }
                            return monthClass;
                        };

                        // $scope.model.aspects.required
                        vm.updateModel = function () {
                            if (isTouch && vm.selectedDateVariable) {
                                setDate(moment(vm.selectedDateVariable));
                            } else if (vm.showDay && vm.selectedDay && vm.selectedMonth && vm.selectedYear) {
                                    // isDateValid has only to be checked if there are three Date Fields
                                    handleValidationOfAllThreeDateFields();
                            } else if (!vm.showDay && vm.selectedMonth && vm.selectedYear) {
                                    //if we only have month and year we always take the 1st day of the month
                                    setDate(BaslerDateUtilService.getDate(vm.selectedYear, vm.selectedMonth.id, 1));
                            }
                            if(vm.onDateSelect()) {
                                vm.onDateSelect()();
                            }
                        };

                        function handleValidationOfAllThreeDateFields() {
                            // Date validation is only required when day is available, else it's not possible to enter a invalid date
                            const isDateValid = BaslerDateUtilService.isDateValid(vm.selectedYear, vm.selectedMonth.id, vm.selectedDay);
                            if (isDateValid) {
                                setDate(BaslerDateUtilService.getDate(vm.selectedYear, vm.selectedMonth.id, vm.selectedDay));
                            } else {
                                // No Valid Date is set to undefined to pop up default error message (Marco Zirkenbach) --> Validation only works if Field is required
                                setDate(undefined);
                            }
                        }

                        function setDate(date) {
                            if (vm.localDate) {
                                if (date) {
                                    vm.model.value = {
                                        year: date.toDate().getFullYear(),
                                        month: date.toDate().getMonth(),
                                        day: date.toDate().getDate(),
                                    };
                                    if (isTouch) {
                                        vm.selectedDateVariable = date.toDate();
                                    }
                                } else {
                                    vm.model.value = undefined;
                                }
                            } else {
                                vm.model.value = date ? date.toDate() : undefined;
                            }
                        }
                    }],
                };
            }];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerDateCombo.js